import { handleActions } from 'redux-actions'

import {
  resetReferralSource,
  setReferralSourceItem,
  setReferralSourceList
} from 'src/store/modules/admin/referralSource'

const initialState = {
  referralSourceItem: {},
  referralSourceList: []
}

export default handleActions(
  {
    [setReferralSourceItem](state, { payload: referralSourceItem }) {
      return {
        ...state,
        referralSourceItem
      }
    },

    [setReferralSourceList](state, { payload: referralSourceList }) {
      return {
        ...state,
        referralSourceList
      }
    },

    [resetReferralSource]() {
      return initialState
    }
  },
  initialState
)
